/* @flow */

let initialState: { locale: string } = { 
  locale: navigator.language || navigator.userLanguage,
};

export function intl(state:Object = initialState, action:Object) {
    return state;
}
